export default [
	{
		tenantId: 'b16e03a6-17bb-4f0c-b316-9ec017e51d5a',
		labels: {
			signUpUserTypeButtonCompany: 'Practice',
			signUpUserTypeButtonProfessional: 'Locum',
			signUpUserTypeDescriptionCompany: 'Select above if you own/manage a Practice/Hospital',
			signUpUserTypeDescriptionProfessional: 'Select above if you want to work as a Locum',
			industry: 'Industry',
			industryRequired: 'Industry is required',
		},
	},
	{
		tenantId: '3f5a9c8a-4a78-4723-a9bd-3f43b18fe5be',
		labels: {
			signUpUserTypeButtonCompany: 'Venue',
			signUpUserTypeButtonProfessional: 'Shift Seeker',
			signUpUserTypeDescriptionCompany: 'Select above if you want to work as a Venue',
			signUpUserTypeDescriptionProfessional: 'Select above if you want to work as a Shift Seeker',
			industry: 'Category',
			industryRequired: 'Category is required',
		},
	},
];
